import { render, staticRenderFns } from "./FiltersButton.vue?vue&type=template&id=1146d663"
import script from "./FiltersButton.vue?vue&type=script&lang=js"
export * from "./FiltersButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports